import { render, staticRenderFns } from "./IndividualSalesPerformance.vue?vue&type=template&id=54becc5a&scoped=true"
import script from "./IndividualSalesPerformance.vue?vue&type=script&lang=js"
export * from "./IndividualSalesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54becc5a",
  null
  
)

export default component.exports